import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Typography from 'Components/UI/Typography';

const styles = (theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
});

const BulkCommunicationSummaryStat = ({
  className,
  classes,
  label,
  value,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Typography
        className={classes.title}
        color={'primary'}
        variant={'h6'}
      >
        {label}
      </Typography>
      <Typography
        className={classes.value}
        color={'primary'}
        variant={'h2'}
        weight={'bold'}
      >
        {value}
      </Typography>
    </Box>
  );
};

BulkCommunicationSummaryStat.defaultProps = {
  className: '',
};

BulkCommunicationSummaryStat.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default withStyles(styles)(BulkCommunicationSummaryStat);
